// extracted by mini-css-extract-plugin
module.exports = {"preview":"connection-label_preview__3uD9Q","cell":"connection-label_cell__4--8B"};